import { components } from "react-select";
import type { MaterialRequestOption } from "../types/material-request.types";
import {
  MaterialRequestStatusMap,
  MaterialRequestSourceTypeLabel,
} from "../constants/material-request.constants";
import { DateOnly } from "components/common/Date";

function statusBadgeClass(status: string | undefined): string {
  const color = status
    ? (MaterialRequestStatusMap[status]?.color ?? "secondary")
    : "secondary";
  return `badge bg-${color}-subtle text-${color} fw-medium`;
}

export function MrSelectOption(props: any) {
  const d = props.data as MaterialRequestOption;
  const sourceLabel = d.sourceType
    ? ((MaterialRequestSourceTypeLabel as Record<string, string>)[d.sourceType] ?? d.sourceType)
    : null;

  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1 gap-1">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <span className="fw-semibold text-body">{d.code ?? d.label}</span>
          {d.status ? (
            <span className={statusBadgeClass(d.status)}>
              {MaterialRequestStatusMap[d.status]?.label ?? d.status}
            </span>
          ) : null}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          {sourceLabel ? (
            <small className="text-muted">
              {sourceLabel}
              {d.sourceId != null ? ` #${d.sourceId}` : ""}
            </small>
          ) : null}
          {d.requiredDate ? (
            <small className="text-muted">
              · Required by <DateOnly date={d.requiredDate} />
            </small>
          ) : null}
        </div>
      </div>
    </components.Option>
  );
}

export function MrSelectMultiValue(props: any) {
  const d = props.data as MaterialRequestOption;
  return (
    <components.MultiValue {...props}>
      <components.MultiValueLabel {...props}>
        {d.code ?? d.label}
      </components.MultiValueLabel>
    </components.MultiValue>
  );
}
